/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { PatientInterface, HeaderEnum } from "medicalsystem-shared";
import useHttp from "hooks/http.hook";
import Button from "components/generals/Button";
import Box from "components/generals/Box";
import { Caption, H5, H4 } from "components/generals/_Titles";
import AppointmentWidget from "components/widgets/AppointmentWidget";
import Card from "components/generals/Card";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CoreAPI_URLs } from "constants/http.const";
import { PatientInsuranceInterface, QueryResultInterface } from "medicalsystem-shared";
import { useEffect, useState } from "react";
import InsurancePatientHubTable from "components/tables/InsurancePatientHub";
//TODO: REMOVE MOCK DATA
/**
 * Props for PatientHubForm component.
 */
interface PatientHubFormInterface {
  patientModel: PatientInterface;
}

/**
 * Patient hub summary form displaying key patient information widgets.
 * 
 * Features:
 * - Appointment widget showing upcoming and past appointments
 * - Insurance information table
 * - Responsive grid layout (2 columns on desktop, stacked on mobile)
 * - Automatic data fetching on component mount
 * - Empty state handling with informative messages
 * - Integration with patient insurance API
 * 
 * Displays:
 * - Patient appointment history and scheduling
 * - Active insurance policies and coverage details
 * - Quick access to patient-related actions
 * 
 * @param patientModel - Patient data to display in hub widgets
 * @returns Patient hub form with appointment and insurance widgets
 */
const PatientHubForm: React.FC<PatientHubFormInterface> = ({ patientModel }) => {
  const [_isLoading, _error, sendRequest] = useHttp();
  const { t } = useTranslation();

  const [insuranceListResponse, setInsuranceListResponse] = useState<PatientInsuranceInterface[]>([]);

  useEffect(() => {
    sendRequest(CoreAPI_URLs.PATIENT_INSURANCE_GET_ALL, onGetPharmacies, "GET", null,[{ header: HeaderEnum.PATIENT_ID, value: patientModel.id }]);
  }, []);

  const onGetPharmacies = (insuranceResponse: QueryResultInterface<PatientInsuranceInterface>) => {
    setInsuranceListResponse(insuranceResponse.results);
  };

  return (
    <>
      {patientModel ? (
<Box mt={2} mb={2} width="100%">
  <Grid container spacing={4} alignItems="stretch">
    <Grid item xs={12} md={6} style={{ display: 'flex' }}>
      <Card id="2" style={{ padding: '1rem', width: '100%' }}>
        <AppointmentWidget patientSelected={patientModel} />
      </Card>
    </Grid>
    <Grid item xs={12} md={6} style={{ display: 'flex' }}>
      <Card id="2" style={{ padding: '1rem', width: '100%' }}>
        {insuranceListResponse.length > 0 ? (
          <>
          <H4>{t("patientHubForm.insurance")}</H4>
          <InsurancePatientHubTable patientSelected={patientModel} />
          </>
        ) : (
          <>
            <H4 marginTop={2}>{t("patientHubForm.insurance")}</H4>
            <H5>{t("patientHubForm.noInformationAvailable")}</H5>
          </>
        )}
      </Card>
    </Grid>
  </Grid>
</Box>
      ) : (
        <H5>{t("patientHubForm.noInformationAvailable")}</H5>
      )}
    </>
  );
};

export default PatientHubForm;
